// extracted by mini-css-extract-plugin
export default {"menu":"menu--KS1xu","content":"content--Gu8QB"};